import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=92dde6b4&scoped=true"
import script from "./detail.vue?vue&type=script&lang=js"
export * from "./detail.vue?vue&type=script&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=92dde6b4&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92dde6b4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92dde6b4')) {
      api.createRecord('92dde6b4', component.options)
    } else {
      api.reload('92dde6b4', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=92dde6b4&scoped=true", function () {
      api.rerender('92dde6b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/mdm/views/dealer_address/logs/detail.vue"
export default component.exports